import { transliterate } from 'transliteration';
  
export const generateLogin = (
  secondName: string,
  firstName: string,
  middleName: string,
  existingLogins: string[] = []
): string => {
  const translitSecondName = transliterate(secondName).toLowerCase();
  const translitFirstName = transliterate(firstName).toLowerCase();
  const translitMiddleName = transliterate(middleName).toLowerCase();

  const loginVariants = [
    translitSecondName[0] + translitFirstName[0] + translitMiddleName[0],
    translitSecondName.slice(0, 2) + translitFirstName[0] + translitMiddleName[0],
    translitSecondName.slice(0, 3) + translitFirstName[0] + translitMiddleName[0]
  ];

  for (const variant of loginVariants) {
    if (!existingLogins.includes(variant)) {
      return variant;
    }
  }

  let count = 1;
  const baseLogin = loginVariants[0];
  const maxAttempts = 100;

  while (count <= maxAttempts) {
    const loginWithNumber = `${baseLogin}${count}`;
    if (!existingLogins.includes(loginWithNumber)) {
      return loginWithNumber;
    }
    count++;
  }

  return `${baseLogin}${Date.now().toString().slice(-4)}`;
};

export const generatePassword = (): string => {
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';
  const specials = '!@#$%^&*()_+-=[]{}|;:,.<>?';

  const randomLower = lowercase[Math.floor(Math.random() * lowercase.length)];
  const randomUpper = uppercase[Math.floor(Math.random() * uppercase.length)];
  const randomNumber = numbers[Math.floor(Math.random() * numbers.length)];
  const randomSpecial = specials[Math.floor(Math.random() * specials.length)];

  const allChars = lowercase + uppercase + numbers + specials;
  let otherChars = '';
  for (let i = 0; i < 6; i++) {
    otherChars += allChars[Math.floor(Math.random() * allChars.length)];
  }

  const passwordChars = [randomLower, randomUpper, randomNumber, randomSpecial, ...otherChars.split('')];
  // Функция для перемешивания массива (алгоритм Фишера-Йетса)
  const shuffleArray = (array: string[]) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  return shuffleArray(passwordChars).join('');
};
